// src/components/MinecraftSection.jsx
import { Trees, Castle, MessageCircle, Sword, Sparkles, Mountain, Coffee, ClipboardCopy, Coins, ShoppingBag, Gamepad2 } from "lucide-react";
import { useServerStatus } from "../hooks/useServerStatus";

const mcTags = [
  { icon: <Trees className="toa-ico-sm" />,         label: "Survival SMP" },
  { icon: <Sword className="toa-ico-sm" />,         label: "Factions" },
  { icon: <Castle className="toa-ico-sm" />,        label: "Roleplay" },
  { icon: <ShoppingBag className="toa-ico-sm" />,   label: "Economy" },
  { icon: <Gamepad2 className="toa-ico-sm" />,      label: "Minigames" },
  { icon: <MessageCircle className="toa-ico-sm" />, label: "Voice Chat" },
  { icon: <Sparkles className="toa-ico-sm" />,      label: "Custom Items" },
  { icon: <Mountain className="toa-ico-sm" />,      label: "Java + Bedrock" },
];

export default function MinecraftSection({ onCopyIP, onOpenStore, onOpenMcStore, onOpenMcPage }) {
  const { minecraft, loaded } = useServerStatus();
  const mcOnline = loaded ? minecraft.online : null;

  return (
    <div id="mc" className="toa-mc-outer">
      <div className="toa-mcs">
        <div className="toa-slbl">Play With Us</div>
        <div className="toa-stit">Minecraft Server</div>
        <div className="toa-sdiv" />
        <div className="toa-mcb">
          <div>
            {/* Server address + status - stacks cleanly on mobile */}
            <div className="toa-mc-server-row">
              <div className="toa-mct">play.theonesabove.org</div>
              <span className="toa-mc-status-pill" style={{
                background: mcOnline === null ? "rgba(100,100,100,.1)" : mcOnline ? "rgba(74,222,128,.1)" : "rgba(239,68,68,.1)",
                border: `1px solid ${mcOnline === null ? "rgba(100,100,100,.2)" : mcOnline ? "rgba(74,222,128,.25)" : "rgba(239,68,68,.25)"}`,
                color: mcOnline === null ? "#888" : mcOnline ? "#4ade80" : "#ef4444",
              }}>
                <span className="toa-mc-status-dot" style={{
                  background: mcOnline === null ? "#888" : mcOnline ? "#4ade80" : "#ef4444",
                }} />
                {mcOnline === null ? "Checking..." : mcOnline
                  ? `Online · ${minecraft.playerCount}/${minecraft.maxPlayers}`
                  : "Offline"}
              </span>
            </div>

            <div className="toa-mc-platform">
              <Coffee className="toa-ico-sm" /> Java&nbsp;+&nbsp;
              <Mountain className="toa-ico-sm" /> Bedrock&nbsp;·&nbsp;Cross-Platform
            </div>

            <p className="toa-mcd">
              A survival SMP with Factions, a player-driven economy, custom actions, proximity voice chat, custom items, and embedded roleplay -
              all set in a persistent living world shaped by the brotherhood. Whether you build, fight, trade, or roleplay,
              there's a place for you here.
            </p>

            {/* Copy IP - hint text hidden on mobile */}
            <div className="toa-mc-ip" onClick={onCopyIP}>
              <ClipboardCopy className="toa-ico-sm" />
              play.theonesabove.org
              <span className="toa-mc-copy-hint">(click to copy)</span>
            </div>

            <div className="toa-mc-tags">
              {mcTags.map(({ icon, label }) => (
                <div key={label} className="toa-mc-tag">{icon} {label}</div>
              ))}
            </div>

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button onClick={onOpenMcPage} className="toa-btn toa-btn-p" style={{ fontSize: 12, padding: "9px 18px" }}>
                More Information
              </button>
            </div>
          </div>

          <div className="toa-mc-spawn-img" style={{ width: 420, minWidth: 320, height: 280, flexShrink: 0, borderRadius: 12, overflow: "hidden", filter: "drop-shadow(0 0 16px rgba(120,80,200,.35))" }}>
            <img src="/spawn.png" alt="Minecraft Server" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          </div>
        </div>
      </div>
    </div>
  );
}